import { gql } from 'graphql-tag'
import fragmentEventLocation from '../event-location/fragment-event-location'
import fragmentEventAgendaSection from '../event-agenda-section/fragment-event-agenda-section'

export default gql`
  ${fragmentEventLocation}
  ${fragmentEventAgendaSection}
  fragment EventFormBlockFragment on EventFormBlock {
    sys {
      id
    }
    contentType: __typename
    title
    formBlockDescription: description {
      json
    }
    eventAgendaOrLocationSection {
      ... on EventAgendaSection {
        ...EventAgendaSectionFragment
      }
      ... on EventLocation {
        ...EventLocationFragment
      }
    }
  }
`
